function typeText(element, text, onComplete) {
  const cursor = document.createElement('span');
  cursor.className = 'cursor';
  cursor.textContent = '|';
  element.appendChild(cursor);

  const words = text.split(' ');
  let wordIndex = 0;
  let charIndex = 0;
  let currentText = '';
  let speedfactor = 1.0;
  let timeoutId = null;
  let cancelled = false;

  function typeNextChar() {
    if (cancelled) return;

    if (wordIndex >= words.length) {
      cursor.remove();
      if (onComplete) onComplete();
      return;
    }

    const currentWord = words[wordIndex];

    if (charIndex < currentWord.length) {
      currentText += currentWord[charIndex];
      element.textContent = currentText;
      element.appendChild(cursor);
      charIndex++;
      timeoutId = setTimeout(typeNextChar, 30);
    } else {
      // Finished current word, add space and move to next
      if (wordIndex < words.length - 1) {
        currentText += ' ';
        element.textContent = currentText;
        element.appendChild(cursor);
      }
      wordIndex++;
      charIndex = 0;
      timeoutId = setTimeout(typeNextChar, 50); // Pause between words (25% faster)
    }
  }

  typeNextChar();

  // Return cancellation function
  return {
    cancel: () => {
      cancelled = true;
      if (timeoutId) clearTimeout(timeoutId);
      cursor.remove();
      element.textContent = text;
      if (onComplete) onComplete();
    }
  };
}

const typingText1 = document.getElementById('typing-text-1');
const typingText2 = document.getElementById('typing-text-2');

function prepareFlyingSections() {
  // Convert legacy inline animations to data attributes and neutralize early start
  const legacy = document.querySelectorAll('[style*="animation: flyIn"]');
  legacy.forEach((el) => {
    const style = el.getAttribute('style') || '';
    const match = style.match(/animation:\s*flyIn\s+[^;]*?\s(\d+(?:\.\d+)?)s\s+both/);
    if (match) {
      const delay = match[1];
      if (!el.dataset.flyDelay) {
        el.dataset.flyDelay = delay;
      }
    }
    // Remove animation so it won't run before we trigger it
    el.style.animation = 'none';
    // Keep initial transform/opacity from markup
  });
}

function getFlySectionsSorted() {
  const sections = Array.from(document.querySelectorAll('[data-fly-delay]'));
  sections.sort((a, b) => parseFloat(a.dataset.flyDelay) - parseFloat(b.dataset.flyDelay));
  return sections;
}

function startFlyingAnimations() {
  const sections = getFlySectionsSorted();
  console.log('Homepage: Arming flying animations for', sections.length, 'sections');
  if (sections.length === 0) return;

  // Normalize so the first element starts immediately after typing finishes,
  // preserving the relative staggering between items.
  const firstDelay = Math.min(
    ...sections.map((el) => parseFloat(el.dataset.flyDelay || '0'))
  );
  const basePostTypingDelay = 0.12; // small breathing room

  sections.forEach((el) => {
    const original = parseFloat(el.dataset.flyDelay || '0');
    const relative = Math.max(0, original - firstDelay) + basePostTypingDelay;
    el.style.animation = `flyIn 0.45s ease-out ${relative}s both`;
  });

  // Calculate when to trigger navbar (partway through flying animations)
  const maxDelay = Math.max(
    ...sections.map((el) => parseFloat(el.dataset.flyDelay || '0'))
  );
  const relativeMaxDelay = Math.max(0, maxDelay - firstDelay) + basePostTypingDelay;
  const navbarTriggerTime = (relativeMaxDelay + 0.45) * 0.6; // Start navbar at 60% through animations

  setTimeout(() => {
    console.log('Homepage: Triggering navbar animation before boxes complete');
    window.dispatchEvent(new CustomEvent('homepage-animation-complete'));
  }, navbarTriggerTime * 1000);

  const last = sections[sections.length - 1];
  if (last) {
    console.log('Homepage: Monitoring last section completion');
  }
}

if (typingText1 && typingText2) {
  // Ensure flying sections won't start early
  prepareFlyingSections();

  let animationState = {
    typing1: null,
    typing2: null,
    timeouts: [],
    completed: false
  };

  // Click anywhere to skip animation
  const skipHandler = () => {
    if (animationState.completed) return;

    console.log('Homepage: Animation skip triggered');
    animationState.completed = true;

    // Cancel typing animations
    if (animationState.typing1) animationState.typing1.cancel();
    if (animationState.typing2) animationState.typing2.cancel();

    // Clear all timeouts
    animationState.timeouts.forEach(id => clearTimeout(id));
    animationState.timeouts = [];

    // Show final text with underline
    const wrappedHtml = typingText1.innerHTML.replace(/Fast\./g, '<span class="underline-fast show-underline">Fast.</span>');
    typingText1.innerHTML = wrappedHtml;

    // Instantly fade in all flying sections
    const sections = getFlySectionsSorted();
    sections.forEach(el => {
      el.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
      el.style.transform = 'translateX(0)';
      el.style.opacity = '1';
      el.style.animation = 'none';
    });

    // Trigger navbar immediately
    window.dispatchEvent(new CustomEvent('homepage-animation-complete'));

    // Remove click handler
    document.removeEventListener('click', skipHandler);
  };

  document.addEventListener('click', skipHandler);

  animationState.typing1 = typeText(typingText1, 'Too slow, too tangled, or too important to guess at.', () => {
    if (animationState.completed) return;

    // Wrap "guess at." in a span with underline class
    const html = typingText1.innerHTML;
    const wrappedHtml = html.replace(/guess at\./g, '<span class="underline-fast">guess at.</span>');
    typingText1.innerHTML = wrappedHtml;

    // Show underline after first line completes
    const timeout1 = setTimeout(() => {
      if (animationState.completed) return;

      const underlineSpan = typingText1.querySelector('.underline-fast');
      if (underlineSpan) {
        underlineSpan.classList.add('show-underline');
      }
      // After underline animates, type second line; when done, start flying boxes
      const timeout2 = setTimeout(() => {
        if (animationState.completed) return;

        animationState.typing2 = typeText(typingText2, 'Independent diagnosis for software systems that have outgrown easy answers.', () => {
          if (animationState.completed) return;
          animationState.completed = true;
          document.removeEventListener('click', skipHandler);
          startFlyingAnimations();
        });
      }, 300); // Wait for underline animation (25% faster)
      animationState.timeouts.push(timeout2);
    }, 150); // Brief pause before underline (25% faster)
    animationState.timeouts.push(timeout1);
  });
}
